import { useTranslation } from 'react-i18next';
import { IFormInstance, useWatchForm } from '@/components';
import { useGetRequiredRule } from '@/hooks';
import { ApproveFaqFieldsNames } from '../helpers';

const useApproveFaqFormRules = (form: IFormInstance) => {
  const { t } = useTranslation();
  const requiredRule = useGetRequiredRule({ t });
  const isGeneral = useWatchForm(ApproveFaqFieldsNames.IS_GENERAL, form);

  return {
    [ApproveFaqFieldsNames.CHANNEL_IDS]: isGeneral ? [] : [requiredRule],
  };
};

export default useApproveFaqFormRules;
